import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[hiddenContent]',
})
export class HiddenContentDirective implements OnInit {
  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.el.nativeElement.style.whiteSpace = 'nowrap';
    this.el.nativeElement.style.overflow = 'hidden';
    this.el.nativeElement.style.textOverflow = 'ellipsis';
  }
}
